module.exports = __webpack_public_path__ + "static/media/NurseM1.44bbcf27.jpg";